import type { SvgIconComponent } from "@mui/icons-material";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";

import { PercentageStatus } from "~/components/UI/PercentageComponent/types";

export const ICON_BY_STATUS: Record<PercentageStatus, SvgIconComponent | null> =
  {
    [PercentageStatus.GROW]: ArrowUpwardIcon,
    [PercentageStatus.DECLINE]: ArrowDownwardIcon,
    [PercentageStatus.NEUTRAL]: null,
  };

export const COLOR_BY_STATUS: Record<PercentageStatus, string> = {
  [PercentageStatus.GROW]: "success.main",
  [PercentageStatus.DECLINE]: "error.main",
  [PercentageStatus.NEUTRAL]: "primary.text",
};
